import React from 'react'
import classNames from 'classnames'
import { InjectHtml } from '@/components/ui'
import type { IFinancingBlockContainerProps } from './interfaces'
import './styles.scss'

const LandingBlockContainer: React.FC<IFinancingBlockContainerProps> = props => {
  const {
    title,
    titleId,
    descriptionId,
    children,
    className,
    descriptionClassName = 'space-holder32',
    titleClassName = 'space-holder32',
    withoutPageWrapper,
    blockId,
  } = props

  return (
    <section className={classNames('landing-block-container', className, { 'page-wrapper': !withoutPageWrapper })} id={blockId}>
      <InjectHtml
        textId={titleId}
        html={title}
        TagName="h2"
        className={classNames(titleClassName, { 'page-wrapper': withoutPageWrapper })}
      />
      <InjectHtml textId={descriptionId} TagName="p" className={classNames(descriptionClassName, { 'page-wrapper': withoutPageWrapper })} />

      <div>{children}</div>
    </section>
  )
}

export default LandingBlockContainer
